import * as bootstrap from 'bootstrap';

import './index.scss';

const accountPage = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');

        tooltipTriggerList.forEach(el => {
            new bootstrap.Tooltip(el);
        });
    });

	(function () {
        function show(mode) {
            var isLogin = mode === 'login';
            document.getElementById('custom-login-panel').style.display  = isLogin ? '' : 'none';
            document.getElementById('custom-register-panel').style.display = isLogin ? 'none' : '';
            document.getElementById('custom-right-info-register').style.display    = isLogin ? '' : 'none';
            document.getElementById('custom-right-info-login').style.display  = isLogin ? 'none' : '';
        }

        document.addEventListener('DOMContentLoaded', function () {
            document.querySelectorAll('.custom-toggle-btn').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    show(this.dataset.show);
                });
            });
        });
    }());
};

export default accountPage;
